
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
}

.wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  color: var(--neutral-white);
}

@media (min-width: 768px) {

  .wrapper {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1024px) {

  .wrapper {
    padding: 5rem;
  }
}

.image-slot-wrapper {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
  width: 100%;
}

.image-slot-wrapper img {
  display: block;
}

.image-slot-wrapper img {
  height: 100%;
}

.image-slot-wrapper img {
  width: 100%;
}

.image-slot-wrapper img {
  object-fit: cover;
}

.content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
}

@media (min-width: 768px) {

  .content {
    width: 100%;
  }

  .content {
    flex-direction: row;
  }

  .content {
    flex-wrap: nowrap;
  }

  .content {
    align-items: center;
  }

  .content {
    justify-content: space-between;
  }

  .content {
    gap: 0.75rem;
  }

  .content {
    text-align: left;
  }
}

[slot='content'] {
  width: 100%;
}

[slot='cta'] {
  white-space: nowrap;
}

idb-icon{
  margin-top:3px;
  margin-left:10px;
}
`;